module.exports = __webpack_public_path__ + "media/images/talent/feature-image01-4f3e4b1aa9169aed336ee4d3d975a028.png";